import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "clip-path": "url(#a)",
      stroke: "#fff",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("path", { d: "M16.432 3.834a1.437 1.437 0 0 0-1.067 0l-6.12 2.449a1.438 1.438 0 0 1-1.068 0L2.51 4.015a.719.719 0 0 0-.987.671V18.46a1.438 1.438 0 0 0 .904 1.335l5.75 2.3c.343.137.725.137 1.068 0l6.12-2.448a1.438 1.438 0 0 1 1.067 0L22.1 21.91a.72.72 0 0 0 .986-.67V7.47a1.437 1.437 0 0 0-.904-1.336l-5.75-2.3ZM8.71 6.385v15.813M15.898 3.731v15.813" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          transform: "translate(.305 .614)",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }